// PE-6155 — central HTTP error toast for all API failures
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { SnackbarService } from '../services/snackbar.service';
import { isSessionInvalidError } from './session.interceptor';
import { resolveHttpErrorMessage } from '../utils/http-connection-error.util';
import { SKIP_HTTP_ERROR_TOAST } from '../utils/http-error-toast.context';

/**
 * Toasts a user-friendly message for every HTTP failure via resolveHttpErrorMessage.
 * Skips: SKIP_HTTP_ERROR_TOAST context, session-invalid (dialog handles it).
 * Rethrows so callers can still reset loading / UI state.
 */
export const connectionErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const snackbar = inject(SnackbarService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const skipToast = req.context.get(SKIP_HTTP_ERROR_TOAST);
      if (!skipToast && !isSessionInvalidError(error)) {
        console.error('HTTP error', {
          status: error.status,
          statusText: error.statusText,
          url: req.url.split('?')[0],
          name: error.name,
          message: error.message,
        });
        void snackbar.showHttpError(resolveHttpErrorMessage(error));
      }
      return throwError(() => error);
    })
  );
};
